module.exports = __webpack_public_path__ + "static/media/Bubble_Tea_tapioca_pearl-07-512.d692ae59.png";